"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../styles");
var Swipeable_1 = __importDefault(require("../Swipeable"));
var PrintPlus_1 = __importDefault(require("./PrintPlus"));
var PrintMinus_1 = __importDefault(require("./PrintMinus"));
var print1_jpg_1 = __importDefault(require("./assets/print1.jpg"));
var print2_jpg_1 = __importDefault(require("./assets/print2.jpg"));
var print3_jpg_1 = __importDefault(require("./assets/print3.jpg"));
var SPrintTechnology = (0, styled_components_1.default)(PrintTechnology)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var STabs = (0, styled_components_1.default)(Tabs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .titles {\n        display: flex;\n        position: relative;\n        margin-bottom: 20px;\n    }\n\n    .underline {\n        position: absolute;\n        width: 100px;\n        left: 0;\n        bottom: 0;\n        height: 2px;\n        background: #3cb868;\n        border-radius: 4px;\n        transition: 0.3s;\n    }\n\n    .title {\n        padding: 20px 0px;\n        margin-right: 24px;\n        color: #ccc;\n        cursor: pointer;\n        transition: 0.3s;\n        white-space: nowrap;\n\n        &.active,\n        &:hover {\n            color: black;\n        }\n    }\n"], ["\n    .titles {\n        display: flex;\n        position: relative;\n        margin-bottom: 20px;\n    }\n\n    .underline {\n        position: absolute;\n        width: 100px;\n        left: 0;\n        bottom: 0;\n        height: 2px;\n        background: #3cb868;\n        border-radius: 4px;\n        transition: 0.3s;\n    }\n\n    .title {\n        padding: 20px 0px;\n        margin-right: 24px;\n        color: #ccc;\n        cursor: pointer;\n        transition: 0.3s;\n        white-space: nowrap;\n\n        &.active,\n        &:hover {\n            color: black;\n        }\n    }\n"])));
function Tabs(props) {
    var underlineRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(0), active = _a[0], setActive = _a[1];
    var setTab = function (idx) { return function (e) {
        var title = e.target;
        var width = title.clientWidth;
        var left = title.offsetLeft;
        if (underlineRef.current) {
            underlineRef.current.style.left = left + 'px';
            underlineRef.current.style.width = width + 'px';
        }
        setActive(idx);
    }; };
    return (react_1.default.createElement("div", { className: props.className },
        react_1.default.createElement(Swipeable_1.default, null,
            react_1.default.createElement("div", { className: "titles" },
                react_1.default.createElement("div", { className: "underline", ref: underlineRef }),
                props.titles.slice(0, props.titles.length).map(function (tabTitle, idx) {
                    return react_1.default.createElement("div", { key: idx, className: (0, classnames_1.default)('title', active === idx && 'active'), onClick: setTab(idx) }, tabTitle);
                }))),
        react_1.default.createElement("div", { className: "tab" }, props.children[active])));
}
var PrintTab = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n\n    img {\n        border-radius: 20px;\n        min-width: 300px;\n    }\n\n    @media (max-width: 1024px) {\n        flex-wrap: wrap;\n        justify-content: space-between;\n\n        img {\n            flex-basis: 100%;\n        }\n    }\n"], ["\n    display: flex;\n\n    img {\n        border-radius: 20px;\n        min-width: 300px;\n    }\n\n    @media (max-width: 1024px) {\n        flex-wrap: wrap;\n        justify-content: space-between;\n\n        img {\n            flex-basis: 100%;\n        }\n    }\n"])));
function PrintTechnology(props) {
    return (react_1.default.createElement(styles_1.Section, { className: props.className },
        react_1.default.createElement(styles_1.SectionTitle, null, "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0435\u0447\u0430\u0442\u0438"),
        react_1.default.createElement(STabs, { titles: ['Прямая печать', 'Шелкография', 'Сублимация'] },
            react_1.default.createElement(PrintTab, null,
                react_1.default.createElement("img", { src: print1_jpg_1.default }),
                react_1.default.createElement(PrintPlus_1.default, { btnHref: "/services/cifrovaja-pechat/" },
                    'Высокое качество изображения',
                    'Подходит для хлопка и натуральных тканей',
                    'Скорость печати',
                    'Цена для малого тиража'),
                react_1.default.createElement(PrintMinus_1.default, { btnHref: "/services/cifrovaja-pechat/" },
                    'Пригодна для небольших тиражей',
                    'Лучше подходит для светлой одежды',
                    'Изображение переносится достаточно долго')),
            react_1.default.createElement(PrintTab, null,
                react_1.default.createElement("img", { src: print3_jpg_1.default }),
                react_1.default.createElement(PrintPlus_1.default, { btnHref: "/services/shelkografija/" },
                    'Подходит для синтетичческих материалов',
                    'Любые тиражи',
                    'Высокое качество картинки',
                    'Можно запечатывать футболки целиком'),
                react_1.default.createElement(PrintMinus_1.default, { btnHref: "/services/shelkografija" },
                    'Исскаженная цветопередача на хлопке',
                    'Изображение лучше ложиться на изделия светлого тона')),
            react_1.default.createElement(PrintTab, null,
                react_1.default.createElement("img", { src: print2_jpg_1.default }),
                react_1.default.createElement(PrintPlus_1.default, { btnHref: "/services/sublimacionnaja-pechat/" },
                    'Подходит для больших теражей',
                    'Стойкое изображение',
                    'Высокое качество картинки'),
                react_1.default.createElement(PrintMinus_1.default, { btnHref: "/services/sublimacionnaja-pechat/" },
                    'Невыгодно печатать большие партии',
                    'Низкая яркость изображения на натуральных тканях')))));
}
exports.default = SPrintTechnology;
var templateObject_1, templateObject_2, templateObject_3;
